import { render, staticRenderFns } from "./CorporateAnnouncementBondRow.vue?vue&type=template&id=5b22d235&scoped=true"
import script from "./CorporateAnnouncementBondRow.vue?vue&type=script&lang=js"
export * from "./CorporateAnnouncementBondRow.vue?vue&type=script&lang=js"
import style0 from "./CorporateAnnouncementBondRow.vue?vue&type=style&index=0&id=5b22d235&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b22d235",
  null
  
)

export default component.exports